import "./TemporaryBackupForm.scss";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";
import {
  renderInputCsltStr,
  renderInputManager,
  renderInputMissionDates,
} from "../CommonInputs";
import {
  MISSION_FORM_LABELS,
  TEMPORARY_BACKUP_LABELS,
  TEMPORARY_BACKUP_PLACEHOLDERS,
} from "constants/forms";

const TemporaryBackupForm = ({
  apiErrorResponse,
  cellHighlight,
  control,
  errors,
  getNamesByFilters,
  namesByFilters,
  lang,
  managerValue,
  register,
  setValue,
  watch,
}) => {
  const worker_id = watch("worker_id");
  const arrival_date_replacement = watch("arrival_date_replacement");
  const replacement_start_date = watch("replacement_start_date");
  const replacement_end_date = watch("replacement_end_date");
  const departure_date_of_replacement = watch("departure_date_of_replacement");

  const getFieldError = (fieldName) =>
    errors?.[fieldName] ||
    (apiErrorResponse?.[fieldName]
      ? { type: "api", message: apiErrorResponse[fieldName], ref: fieldName }
      : undefined);

  const mergedErrors = {
    worker_id: getFieldError("worker_id"),
    arrival_date_replacement: getFieldError("arrival_date_replacement"),
    replacement_start_date: getFieldError("replacement_start_date"),
    replacement_end_date: getFieldError("replacement_end_date"),
    departure_date_of_replacement: getFieldError("departure_date_of_replacement"),
  };

  return (
    <div className="section">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
            id="temporary_backup"
            defaultMessage="Backup temporaire"
          />
        }
      />
      <div className="temporary-backup">
        <div className="temporary-backup-form">
          <div
            className={`cell-padding ${
              (!worker_id?.length && cellHighlight) ||
              errors?.["worker_id"] ||
              apiErrorResponse?.["worker_id"]
                ? "errorCellColor"
                : ""
            }`}
          >
            {renderInputCsltStr({
              control,
              register,
              errors: mergedErrors,
              getNamesByFilters,
              namesByFilters,
              label: TEMPORARY_BACKUP_LABELS.worker_id,
              placeholder: TEMPORARY_BACKUP_PLACEHOLDERS.worker_id,
              setValue,
              value: worker_id,
              profile: ["cslt", "str"],
              errorMessage: apiErrorResponse?.["worker_id"] || errors?.["worker_id"]?.message || null,
            })}
          </div>
          <div
            className={`cell-padding ${
              (!arrival_date_replacement && cellHighlight) ||
              errors?.["arrival_date_replacement"] ||
              apiErrorResponse?.["arrival_date_replacement"]
                ? "errorCellColor"
                : ""
            }`}
          >
            {renderInputMissionDates({
              control,
              label: TEMPORARY_BACKUP_LABELS.arrival_date_replacement,
              register,
              lang,
              name: "arrival_date_replacement",
              id: "arrival_date_replacement",
              required: true,
              errors: mergedErrors,
              setValue,
              value: arrival_date_replacement,
              errorMessage: apiErrorResponse?.["arrival_date_replacement"] || errors?.["arrival_date_replacement"]?.message || null,
            })}
          </div>
          <div
            className={`cell-padding ${
              (!replacement_start_date && cellHighlight) ||
              errors?.["replacement_start_date"] ||
              apiErrorResponse?.["replacement_start_date"]
                ? "errorCellColor"
                : ""
            }`}
          >
            {renderInputMissionDates({
              control,
              label: TEMPORARY_BACKUP_LABELS.replacement_start_date,
              register,
              lang,
              name: "replacement_start_date",
              id: "replacement_start_date",
              required: true,
              errors: mergedErrors,
              setValue,
              min: arrival_date_replacement,
              dateOrderErrorMessage: "backup_dates_error",
              value: replacement_start_date,
              errorMessage: apiErrorResponse?.["replacement_start_date"] || errors?.["replacement_start_date"]?.message || null,
            })}
          </div>
          <div
            className={`cell-padding ${
              (!replacement_end_date && cellHighlight) ||
              errors?.["replacement_end_date"] ||
              apiErrorResponse?.["replacement_end_date"]
                ? "errorCellColor"
                : ""
            }`}
          >
            {renderInputMissionDates({
              control,
              label: TEMPORARY_BACKUP_LABELS.replacement_end_date,
              register,
              lang,
              name: "replacement_end_date",
              id: "replacement_end_date",
              required: true,
              errors: mergedErrors,
              setValue,
              min: replacement_start_date,
              dateOrderErrorMessage: "backup_dates_error",
              value: replacement_end_date,
              errorMessage: apiErrorResponse?.["replacement_end_date"] || errors?.["replacement_end_date"]?.message || null,
            })}
          </div>
          <div
            className={`cell-padding ${
              (!departure_date_of_replacement && cellHighlight) ||
              errors?.["departure_date_of_replacement"] ||
              apiErrorResponse?.["departure_date_of_replacement"]
                ? "errorCellColor"
                : ""
            }`}
          >
            {renderInputMissionDates({
              control,
              label: TEMPORARY_BACKUP_LABELS.departure_date_of_replacement,
              register,
              lang,
              name: "departure_date_of_replacement",
              id: "departure_date_of_replacement",
              required: true,
              errors: mergedErrors,
              setValue,
              min: replacement_end_date,
              dateOrderErrorMessage: "backup_dates_error",
              value: departure_date_of_replacement,
              errorMessage: apiErrorResponse?.["departure_date_of_replacement"] || errors?.["departure_date_of_replacement"]?.message || null,
            })}
          </div>
          <div className="cell-padding cell-disabled">
            {renderInputManager({
              control,
              register,
              name: "manager_id",
              readOnly: true,
              required: false,
              label: MISSION_FORM_LABELS.mission_manager_id,
              placeholder: MISSION_FORM_LABELS.mission_manager_id,
              setValue,
              value: managerValue,
              selectedOptions: managerValue,
              getNamesByFilters,
              namesByFilters,
            })}
          </div>
        </div>
        <div className="temporary-backup-img">
          <img
            src={"/static/img/temporary-backup.png"}
            alt="temporary-backup"
          />
        </div>
      </div>
    </div>
  );
};

TemporaryBackupForm.propTypes = {
  apiErrorResponse: PropTypes.object,
  cellHighlight: PropTypes.bool,
  control: PropTypes.object,
  errors: PropTypes.object,
  getNamesByFilters: PropTypes.func,
  namesByFilters: PropTypes.array,
  lang: PropTypes.string,
  managerValue: PropTypes.array,
  register: PropTypes.func,
  setValue: PropTypes.func,
  watch: PropTypes.func,
};

export default TemporaryBackupForm;
